<template>
    <el-dialog :visible.sync="dialogFormVisible">
        <div class="header flex jcb">
            <span class="fs18 color_333 bold">互联网医生工作平台处方</span>
            <span class="color_main fs15" v-if="info.status!='REBACK'">{{formatterStatus(info.status)}}</span>
            <span class="color_main fs15" v-else>{{formatterSubStatus(info.subStatus)}}</span>
        </div>
        <div class="color_999 fs14 mt5 mb10">
            <p>处方编号：{{info.orderNo}}</p>
            <p>开方时间：{{info.createTime|timeFormat("%Y/%m/%d %H:%M")}}</p>
        </div>
        <div class="bt pt5 pb5 bbd">
            <div><span>患者姓名：{{info.compatName}}</span><span class="ml10">性别：{{info.compatGender|sexFilter(1)}}</span><span class="ml10">年龄：{{info.compatAge}}</span></div>
            <div>初步诊断：{{info.diagnosis}}</div>
        </div>
        <div class="mt10">
          <div v-for="(k,index) in info.drugList" :key="index">
            <div class="flex"><img src="../../../assets/icon/prescription/medicine.png" alt="">
                <span class="fs16 bold ml10" v-if="k.drugType=='PATENT_MEDICINE'">成药药品</span>
                <span class="fs16 bold ml10" v-if="k.drugType=='WESTERN_MEDICINE'">西药药品</span>
                <span class="fs16 bold ml10" v-if="k.drugType=='HERBAL_MEDICINE'">草药药品</span>
            </div>
            <div class="flex column bb">
                <div class="flex column pt10 pb10" :class="{btd:index>0}" >
                    <div class="flex jcb">
                        <div>
                            <span>{{k.drugName}}</span><span class="ml20">{{k.drugSpecification}}</span>
                        </div>
                        <span>￥{{k.drugTotalPrice/100}}</span>
                    </div>
                    <div class="flex jcb">
                        <div>
                            <span>用法用量：</span><span>{{k.admission}}，{{k.frequencyName}}，每次{{k.dosage}}{{k.dosageUnit}}</span>
                        </div>
                        <span>x {{k.amount}}</span>
                    </div>

                </div>
            </div>
            </div>
            <div class="mt20 flex jca">
                <div class="flex1 flex column jcc">
                    <span class="fs14 color_333">处方医生:</span>
                    <img :src="'data:image/png;base64,'+info.openStamp" alt="" class="width50" style="width:50px;">
                </div>
                <div class="flex1 flex column">
                    <span class="fs14 color_333">审核药师:</span>
                    <img :src="'data:image/png;base64,'+info.auditStamp" alt="" style="width:50px;" class="width50" v-if="info.auditStamp&&info.status!='ISSUE'">
                    <span v-else-if="info.status=='ISSUE'">暂未审核</span>
                    <span v-else> </span>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" v-if="info.status=='ISSUE'">
            <el-button size="mini" @click="sub('refuse')">审核拒绝</el-button>
            <el-button type="primary" @click="sub('accept')" size="mini">审核通过</el-button>
        </div>
    </el-dialog>
</template>

<script>
  import {timeFormat, sex} from "ty-vue-filters";
  import {sexFilter} from "../../lib/filters";

  export default {
    name: "check-prescription-dialog",
    props: {
      info: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        dialogFormVisible: false,
        form: {
          recordId: this.info.recordId,
          teamId: this.info.teamId,
          serveIds: []
        },
      }
    },
    filters: {
      sexFilter,
      timeFormat
    },
    methods: {
      show() {
        this.dialogFormVisible = true;
      },
      close(){
        this.dialogFormVisible = false;
      },
      async sub(h) {
        this.$emit('handler',h)
      },
      formatterStatus(code) {
        const statusObj = {
          REBACK: "待发布",
          ISSUE: "待审核",
          AUDIT: "已审核",
          PAY: "已审核",
          SHIPPING: "已审核",
          COMPLETE: "已审核",
          COMMENT: "已审核",
          CANCEL: "已作废",
        };
        return statusObj[code];
      },
      formatterSubStatus(code) {
        const statusObj = {
          REFUSE: "已拒绝",
          RECALL: "已召回"
        };
        return statusObj[code];
      },
    },
  }
</script>

<style scoped lang="scss">
    .management-contract {
        .el-form {
            /*border-top: none;*/
        }
    }
    .bbd{
        border-bottom: 1px #E5E5E5 dashed;
    }
    .btd{
        border-top: 1px #E5E5E5 dashed;
    }


</style>
